module.exports = __webpack_public_path__ + "img/foot-email.9c80b19e.png";